import script from "./ClassScheduleDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassScheduleDialog.vue?vue&type=script&setup=true&lang=js"

import "./ClassScheduleDialog.vue?vue&type=style&index=0&id=31f76e3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f76e3a"]])

export default __exports__